<template>
  <va-dropdown class="notification-dropdown" offset="0, 16px">
    <va-icon
      slot="anchor"
      name="i-nav-notification"
      class="{ 'notification-dropdown__icon--unread' }"
    />
    <div class="notification-dropdown__content pl-3 pr-3 pt-2 pb-2">
      <task-component></task-component>
    </div>
  </va-dropdown>
</template>

<script>
import taskComponent from "./TaskComponent";

export default {
  name: "notification-dropdown",
  components: {
    taskComponent
  }
};
</script>

<style lang="scss">
.notification-dropdown {
  margin-top: 0.3rem;
  cursor: pointer;

  .notification-dropdown__icon {
    position: relative;
    display: flex;
    align-items: center;

    &--unread::before {
      content: "";
      position: absolute;
      right: 0;
      left: 0;
      top: -0.5rem;
      height: 0.375rem;
      width: 0.375rem;
      margin: 0 auto;
      border-radius: 0.187rem;
    }
  }

  &__content {
    background-color: white;
    box-shadow: $gray-box-shadow;
    border-radius: 0.5rem;
    width: 75rem;
    position: absolute;
    top: -0.5rem;
    right: -9rem;
  }

  .va-dropdown__anchor {
    display: inline-block;
  }
}
</style>
